import apiClient from "./apiClient";

export interface CompanyData {
  company_name?: string;
  company_type?: string;
  description?: string;
  industry?: string;
  establishment_date?: string;
  website?: string;
  email?: string;
  phone?: string;
  address?: string;
  city?: string;
  country?: string;
  postal_code?: string;
  tax_id?: string;
  company_size?: string;
  annual_revenue?: number;
  logo_url?: string;
}

export interface TrainingSource {
  title?: string;
  lang?: string;
  text?: string;
}

export interface ChatbotData {
  name?: string;
  description?: string;
  initial_message?: string;
  model?: string;
  persona?: string;
  tone?: string;
  language?: string;
  banned_topics?: string[];
  training_source?: TrainingSource;
}

export interface AnalysisResult {
  company: CompanyData;
  chatbot: ChatbotData;
  training_source?: TrainingSource;
}

export const analyzeWebsite = async (url: string): Promise<AnalysisResult> => {
  const response = await apiClient.post<AnalysisResult>("/onboarding/analyze-website", { url });
  return response;
};

export const analyzePrompt = async (prompt: string): Promise<AnalysisResult> => {
  const response = await apiClient.post<AnalysisResult>("/onboarding/analyze-prompt", { prompt });
  return response;
};

export const completeOnboarding = async (data: AnalysisResult): Promise<{ status: string; company_id: number; chatbot_id: number }> => {
  const response = await apiClient.post<{ status: string; company_id: number; chatbot_id: number }>("/onboarding/complete", data);
  return response;
};
